import CollectionContentLocalesTab from './CollectionContentLocalesTab';

export default CollectionContentLocalesTab;
